import $http from '@/plugins/axios'
import { removeNamespace } from '@/utils/helpers'
import { AuthorSearchType } from '@/utils/enums/author-enums'

export const AUTHORS_TYPES = {
  mutations: {
    SET_LOADING: 'authors/SET_LOADING',
    SET_PAGED_AUTHORS: 'authors/SET_PAGED_AUTHORS',
    SET_TOTAL_AUTHORS_COUNT: 'authors/SET_TOTAL_AUTHORS_COUNT',
    SET_AUTHOR_TABLE_OPTIONS: 'authors/SET_AUTHOR_TABLE_OPTIONS',
    SET_SEARCH_TYPE: 'authors/SET_SEARCH_TYPE',
    SET_SEARCH_IDS: 'authors/SET_SEARCH_IDS'
  },
  actions: {
    fetchAuthorsPaged: 'authors/fetchAuthorsPaged',
    changeSearchType: 'authors/changeSearchType',
    changeSearchIds: 'authors/changeSearchIds'
  }
}

const _types = removeNamespace('authors', AUTHORS_TYPES)

const state = () => ({
  loading: false,
  authorTableOptions: {
    page: 1,
    itemsPerPage: 10,
    keyword: '',
    searchType: AuthorSearchType.Last,
    searchIds: []
  },
  pagedAuthors: [],
  totalAuthorsCount: 0
})

const getters = {}

const mutations = {
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_PAGED_AUTHORS] (state, pagedResult) {
    state.pagedAuthors = pagedResult
  },
  [_types.mutations.SET_TOTAL_AUTHORS_COUNT] (state, count) {
    state.totalAuthorsCount = count
  },
  [_types.mutations.SET_AUTHOR_TABLE_OPTIONS] (state, options) {
    console.log(state)
    state.authorTableOptions = options
  },
  [_types.mutations.SET_SEARCH_TYPE] (state, type) {
    state.authorTableOptions.searchType = type
  },
  [_types.mutations.SET_SEARCH_IDS] (state, ids) {
    state.authorTableOptions.searchIds = ids
  }
}

const actions = {
  [_types.actions.fetchAuthorsPaged] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    const { itemsPerPage, page, keyword, searchType, searchIds } = state.authorTableOptions
    const maxResultCount = itemsPerPage
    const skipCount = (page - 1) * itemsPerPage
    return $http().get(`admin/contributor`, {
      params: {
        skipCount,
        maxResultCount,
        keyword,
        searchType,
        searchIds
      }
    })
      .then((res) => {
        const { items, totalCount } = res
        commit(_types.mutations.SET_PAGED_AUTHORS, items)
        commit(_types.mutations.SET_TOTAL_AUTHORS_COUNT, totalCount)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.changeSearchType] ({ state, commit, dispatch }, searchType) {
    console.log(commit)
    commit(_types.mutations.SET_SEARCH_TYPE, searchType)
  },
  [_types.actions.changeSearchIds] ({ state, commit, dispatch }, searchIds) {
    commit(_types.mutations.SET_SEARCH_IDS, searchIds)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
